export default "__VITE_ASSET__vei92xbi__"